module.exports = __webpack_public_path__ + "static/GratinBlue-ebb12b74ad468226ad857763beb3b6cc.png";